import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Table, Image, Row, Modal, Col, Button, Form } from "react-bootstrap";
import { useHistory } from "react-router";
import moment from "moment";
import ReactStars from "react-rating-stars-component";
// import SuperAdminDeleteOffer from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { ORDER_TYPE } from "../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";

// import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
// import ViewOfferDetailsOffline from "./ViewOfferDetailsOffline";
// import ViewOfferDetailsOnline from "./ViewOfferDetailsOnline";
// import ActiveDeactiveEventsAndOffers from "../../reusableComponents/allPopupReusable/offerEventPopup/ActiveDeactiveEventsAndOffers";
// import ViewOfferDetailsOffline from "../../superAdminComponents/superAdminAllComponent/superAdminUsers/insidePageComponent/FavoritesPageInsideComponent/ViewOfferDetailsOffline";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const RatingReviewTablebody = (props) => {
  const history = useHistory();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const onHandleRedirect = (data) => (e) => {
    if (props.data.isOnline) {
      history.push({
        pathname: `/offer/edit-online-offer/${props.data._id}`,
        state: { editData: data },
      });
    } else {
      history.push({
        pathname: `/offer/edit-offline-offer/${props.data._id}`,
        state: { editData: data },
      });
    }
  };

  const totalpaxvalue = () => {
    let value = 0;
    if (props?.data?.expRequestId?.package?.count < 1) {
      value = ((props?.data?.expRequestId?.adultCount || 0) + (props?.data?.expRequestId?.kidsCount || 0));
      return value
    } else {
      value = ((props?.data?.expRequestId?.adultCount || 0) + (props?.data?.expRequestId?.kidsCount || 0)) + ((props?.data?.expRequestId?.package?.adults + props?.data?.expRequestId?.package?.kids))
      return value
    }
  }

  return (
    <tbody>
      <tr className="super_admin_all_users_table_body">
        <td colSpan="7" className="p-0 w-100">
          <table className="w-100 HideShowTable enMinWidth900">
            <tbody>
              <tr
                className="cursor"
                onClick={
                  props.selectedValue === "0" ||
                    props.selectedValue === "1" ||
                    props.selectedValue === "4"
                    ? ""
                    : showTr
                }
              >
                <td
                  style={{
                    width: `${props.selectedValue === "4" || props.selectedValue === "2"
                      ? "18%"
                      : "20%"
                      }`,
                  }}
                >
                  <div className="d-flex align-items-center">
                    {/* {console.log("Rating Review ==>", props.data)} */}
                    <div className="mr-2 rounded-circle enIMG33 ">
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <Image
                            fluid
                            src={
                              props.data.user_id &&
                                props.data.user_id.profile_photo.length === 0
                                ? require("../../../../assets/images/ActionImages/demoprofile.jpg")
                                : props.data.user_id &&
                                  props.data.user_id.profile_pic_google
                                  ? props.data.user_id.profile_pic_google
                                  : require("../../../../assets/images/ActionImages/demoprofile.jpg") &&
                                    props.data.user_id &&
                                    props.data.user_id.profile_photo
                                    ? props.data.user_id.profile_photo[0]
                                    : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                            }
                            alt="Icon"
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    </div>
                    <div className="super-admin-suggestion-imageBoxTwo">
                      <div className="f12-400">
                        {props.data.user_id &&
                          props.data.user_id.first_name +
                          " " +
                          props.data.user_id.last_name}
                      </div>
                    </div>
                  </div>
                </td>
                {props.selectedValue === "4" || props.selectedValue === "6" ? (
                  <td
                    className="f12-700"
                    style={{
                      width: `${props.selectedValue === "4" ||
                        props.selectedValue === "2"
                        ? "18%"
                        : "20%"
                        }`,
                    }}
                  >
                    {props.selectedValue === "6" ? (
                      <>
                        <div className="d-flex align-items-center">
                          <div
                            className="text-center d-flex flex-column align-items-center"
                            style={{ width: "20%" }}
                          >
                            <SimpleReactLightbox>
                              <SRLWrapper options={options}>
                                <Image
                                  fluid
                                  src={props?.data?.experienceId?.photoThumbnails[0] || NOTAVAILABLEIMAGE}
                                  alt="Icon"
                                />
                              </SRLWrapper>
                            </SimpleReactLightbox>
                          </div>
                          <div className="super-admin-suggestion-imageBoxTwo">
                            <div className="f12-400">
                              {props?.data?.experienceId?.name}
                            </div>
                          </div>
                        </div>
                        {/* <div
                          className={`${props.data.event_id && props.data.event_id.isOnline
                              ? "enSuccessLBL mt-2"
                              : "enPendingLBL mt-2"
                            }`}
                        >
                          {props.data.event_id && props.data.event_id.isOnline
                            ? "Online"
                            : "Offline"}
                        </div> */}
                      </>
                    ) : (
                      <>
                        {/* <div className="d-flex align-items-center"> */}
                        <div className="mr-2 rounded-circle enIMG33 ">
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <Image
                                fluid
                                src={
                                  props.data.item_id &&
                                    props.data.item_id.images
                                    ? props.data.item_id.images[0]
                                    : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                                }
                                alt="Icon"
                              />
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        </div>
                        <div className="super-admin-suggestion-imageBoxTwo d-flex align-items-center mt-2">
                          <div style={{ width: "8%" }} className="mr-2">
                            <Image
                              fluid
                              src={
                                props.data.item_id && props.data.item_id.veg
                                  ? require("../../../../assets/images/UserManagement/veg.svg")
                                  : require("../../../../assets/images/UserManagement/nonveg.svg")
                              }
                              className="w-100"
                              alt="Icon"
                            />
                          </div>
                          <div className="f12-500">
                            {props.data.item_id && props.data.item_id.name}
                          </div>
                        </div>
                        {/* </div> */}
                      </>
                    )}
                  </td>
                ) : null}
                <td
                  style={{
                    width: `${props.selectedValue === "4" || props.selectedValue === "2"
                      ? "15%"
                      : "20%"
                      }`,
                  }}
                >
                  <div className="f12-500 mb-1">
                    {props.data && props.data.rating} Stars
                  </div>
                  <ReactStars
                    count={5}
                    value={props.data && props.data.rating}
                    edit={false}
                    size={22}
                    half={true}
                    emptyIcon={<i className="fa fa-star-o"></i>}
                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                    fullIcon={<i className="fa fa-star"></i>}
                    color2={"#FDD400"}
                  />
                  <div className="f10-500 mt-1">
                    {moment(props.data && props.data.createdAt).format(
                      "Do MMM, YYYY hh:mm A"
                    )}
                  </div>
                </td>
                <td
                  style={{
                    width: `${props.selectedValue === "4" || props.selectedValue === "2"
                      ? "31%"
                      : props.selectedValue === "0"
                        ? "60%"
                        : props.selectedValue === "1"
                          ? "40%"
                          : props.selectedValue === "3" ||
                            props.selectedValue === "5"
                            ? "40%"
                            : "20%"
                      }`,
                  }}
                >
                  <div className="rating-review-table-body-sectiontwo ">
                    <span className="f12-400 enEllips3">
                      {props.data && props.data.review}
                    </span>
                    <ReadMoreModel modelData={props.data && props.data} />
                    <div className="d-flex align-items-center pt-2">
                      <div className="d-flex align-items-center">
                        <div className="opacity5">
                          <Image
                            fluid
                            alt="User Photo"
                            width="12px"
                            src={require("../../../../assets/images/superadmin/like.svg")}
                          />
                        </div>
                        <div className="rating-review-table-body-usertextone">
                          <div className="f10-400 mx-2">
                            {props.data && props.data.likes.length}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <div className="opacity5">
                          <Image
                            fluid
                            alt="User Photo"
                            width="12px"
                            src={require("../../../../assets/images/superadmin/disslike.svg")}
                          />
                        </div>
                        <div className="rating-review-table-body-usertextone">
                          <div className="f10-400 mx-2">
                            {props.data && props.data.dislikes.length}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <div className="opacity5">
                          <Image
                            fluid
                            alt="User Photo"
                            width="12px"
                            src={require("../../../../assets/images/superadmin/chat.svg")}
                          />
                        </div>
                        <div className="rating-review-table-body-usertextone">
                          <div className="f10-400 mx-2">
                            {props.data && props.data.comment.length}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                {props.selectedValue === "0" ? null : (
                  <td
                    style={{
                      width: `${props.selectedValue === "4" ||
                        props.selectedValue === "2"
                        ? "18%"
                        : "20%"
                        }`,
                    }}
                  >
                    {props.selectedValue === "6" ? (
                      <div>
                        <div className="f12-500 mb-2">
                          {
                            props?.data?.experienceId?.expType}
                        </div>
                        <div className="f10-400">
                          {
                            props?.data?.review_id}
                        </div>
                      </div>
                    ) : props.selectedValue === "3" ? (
                      <div>
                        <div className="f12-500 mb-2">
                          {props.data.order_id !== undefined &&
                            props.data.order_id !== null
                            ? ORDER_TYPE[props.data.order_id.order_type]
                            : // props.data.order_id.order_type === 0
                            // ? "Takeaway"
                            // : props.data.order_id.order_type === 1
                            // ? "Curb-side"
                            // : props.data.order_id.order_type === 2
                            // ? "Skip-The Line"
                            // : props.data.order_id.order_type === 3
                            // ? "Dine-In"
                            // : null
                            "-"}
                        </div>
                        <div className="f10-400">
                          {props.data.order_id && props.data.order_id.order_id}
                        </div>
                      </div>
                    ) : props.selectedValue === "4" ? (
                      <div>
                        <div className="f12-500 mb-2">
                          {props.data.event_request_id &&
                            props.data.event_request_id.event_type}
                        </div>
                        <div className="f10-400">
                          {props.data.event_request_id &&
                            props.data.event_request_id.event_request_id}
                        </div>
                      </div>
                    ) : props.selectedValue === "5" ? (
                      <div>
                        <div className="f12-500 mb-2">
                          {props.data.transactional_id &&
                            props.data.transactional_id.transaction_type}
                        </div>
                        <div className="f10-400">
                          {props.data.transactional_id &&
                            props.data.transactional_id._id}
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <div
                          className="image-box-new mr-2"
                          style={{ width: "15%" }}
                        >
                          <Image
                            fluid
                            className="w-100"
                            src={
                              (props.data &&
                                props.data.diner_id &&
                                props.data.diner_id.service_type ===
                                "SEATING") ||
                                (props.data &&
                                  props.data.diner_id &&
                                  props.data.diner_id.isWalkIn === true)
                                ? require("../../../../assets/images/ActionImages/image/walkin.svg")
                                : (props.data &&
                                  props.data.diner_id &&
                                  props.data.diner_id.service_type ===
                                  "SEATING") ||
                                  (props.data &&
                                    props.data.diner_id &&
                                    props.data.diner_id.isWalkIn === false)
                                  ? require("../../../../assets/images/seatingImages/history.svg")
                                  : props.data &&
                                    props.data.diner_id &&
                                    props.data.diner_id.service_type ===
                                    "RESERVATION"
                                    ? require("../../../../assets/images/seatingImages/reservationBlack.png")
                                    : ""
                            }
                          />
                        </div>
                        <div>
                          <div className="f12-500">
                            {(props.data &&
                              props.data.diner_id &&
                              props.data.diner_id.service_type === "SEATING") ||
                              (props.data &&
                                props.data.diner_id &&
                                props.data.diner_id.isWalkIn === true)
                              ? "Walk In"
                              : (props.data &&
                                props.data.diner_id &&
                                props.data.diner_id.service_type ===
                                "SEATING") ||
                                (props?.data?.diner_id?.isWalkIn === false && props?.data?.diner_id?.service_type !== 'RESERVATION')
                                ? "Wait List"
                                : props.data &&
                                  props.data.diner_id &&
                                  props.data.diner_id.service_type ===
                                  "RESERVATION"
                                  ? "Reservation"
                                  : ""}
                          </div>
                          <span className="f10-400">
                            {props.data &&
                              props.data.diner_id &&
                              props.data.diner_id.diner_id}
                          </span>
                        </div>
                      </div>
                    )}
                  </td>
                )}
              </tr>
              {TrDetail.TrDetail && (
                <tr className="border-top">
                  <td style={{ width: "20%" }}>
                    <div className="f11-500 mb-3">
                      {props.selectedValue === "6"
                        ? "Attended Date"
                        : "Ordered Date"}
                    </div>
                    <div className="f11-400">
                      {props.selectedValue === "6"
                        ? moment(
                          props.data &&
                          props.data.experienceId &&
                          props.data.experienceId.createdAt
                        ).format("Do MMM YYYY")
                        : props.selectedValue === "3"
                          ? moment(
                            props.data &&
                            props.data.order_id &&
                            props.data.order_id.createdAt
                          ).format("Do MMM YYYY")
                          : props.selectedValue === "5"
                            ? moment(props.data && props.data.request_time).format(
                              "Do MMM YYYY"
                            )
                            : ""}
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f11-500 mb-3">
                      {props.selectedValue === "2" ? "Time" : "Time"}
                    </div>
                    <div className="f11-400">
                      {props.selectedValue === "6"
                        ? moment(
                          props.data &&
                          props.data.experienceId &&
                          props.data.experienceId.createdAt
                        ).format("hh : mm A")
                        : props.selectedValue === "3"
                          ? moment(
                            props.data &&
                            props.data.order_id &&
                            props.data.order_id.createdAt
                          ).format("hh : mm A")
                          : props.selectedValue === "5"
                            ? moment(props.data && props.data.request_time).format(
                              "hh : mm A"
                            )
                            : ""}
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="f11-500 mb-3">
                      {props.selectedValue === "6"
                        ? "Party Size"
                        : props.selectedValue === "5"
                          ? "Total Amount"
                          : "No. Of Items"}
                    </div>
                    <div className="f11-400">
                      {props.selectedValue === "6"
                        ? ((props?.data?.expRequestId?.adultCount || 0) + (props?.data?.expRequestId?.kidsCount || 0)) + ((props?.data?.expRequestId?.package?.adults + props?.data?.expRequestId?.package?.kids))
                        : props.selectedValue === "3"
                          ? props.data &&
                            props.data.order_id &&
                            (props.data.order_id.order_items !== undefined) !==
                            null
                            ? props.data &&
                            props.data.order_id &&
                            props.data.order_id.order_items.length
                            : ""
                          : props.selectedValue === "5"
                            ? props.data &&
                              props.data.transactional_id &&
                              (props.data.transactional_id.amount !== undefined) !==
                              null
                              ? props.data &&
                              props.data.transactional_id &&
                              props.data.transactional_id.amount
                              : ""
                            : ""}
                    </div>
                  </td>
                  {props.selectedValue === "5" ? (
                    <td style={{ width: "12%" }}>
                      <div className="f11-500 mb-3">Item Name</div>
                      <div className="f11-400"></div>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const ReadMoreModel = (props) => {
  const [showView, setShowView] = useState(false);
  const handleShowView = () => setShowView(true);
  const handleCloseView = () => setShowView(false);

  return (
    <React.Fragment>
      <Button
        className="f12-400 text-red p-0"
        variant="link"
        onClick={handleShowView}
      >
        Read More
      </Button>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    src={
                      props.modelData &&
                        props.modelData.restaurant_id !== undefined
                        ? props.modelData.restaurant_id.logo_url
                        : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                    }
                    alt="View"
                    title="View"
                    fluid
                    className="w-100 h-100"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {props.modelData &&
                    props.modelData.restaurant_id !== undefined
                    ? props.modelData.restaurant_id.restaurant_name
                    : ""}
                </div>
                <div className="f14-400">
                  {props.modelData &&
                    props.modelData.restaurant_id !== undefined
                    ? props.modelData.restaurant_id.restaurant_address
                    : ""}
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <Row>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-start"
            >
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="super-admin-suggestion-imageBoxOne enIMG62 rounded-circle">
                  <SimpleReactLightbox>
                    <SRLWrapper options={options}>
                      <Image
                        fluid
                        src={
                          props.modelData.user_id &&
                            props.modelData.user_id.profile_pic_google
                            ? props.modelData.user_id.profile_pic_google
                            : require("../../../../assets/images/ActionImages/demoprofile.jpg") &&
                              props.modelData.user_id &&
                              props.modelData.user_id.profile_photo
                              ? props.modelData.user_id.profile_photo[0]
                              : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                        }
                        alt="Icon"
                      />
                    </SRLWrapper>
                  </SimpleReactLightbox>
                </div>
                <div className="super-admin-suggestion-imageBoxTwo mt-2">
                  <div className="f12-400">
                    {props.modelData &&
                      props.modelData.user_id &&
                      props.modelData.user_id.first_name +
                      " " +
                      props.modelData.user_id &&
                      props.modelData.user_id.last_name}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              <div>
                <div className="f12-500 mb-1">
                  {props.modelData && props.modelData.rating} Stars
                </div>
                <ReactStars
                  count={5}
                  value={props.modelData && props.modelData.rating}
                  edit={false}
                  size={22}
                  half={true}
                  emptyIcon={<i className="fa fa-star-o"></i>}
                  halfIcon={<i className="fa fa-star-half-alt"></i>}
                  fullIcon={<i className="fa fa-star"></i>}
                  color2={"#FDD400"}
                />
                <div className="f10-500 mt-1">
                  {moment(props.modelData && props.modelData.createdAt).format(
                    "Do MMM, YYYY hh:mm A"
                  )}
                </div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="d-flex align-items-center">
                <div className="image-box-new mr-2">
                  <Image
                    fluid
                    src={
                      (props.modelData &&
                        props.modelData.diner_id &&
                        props.modelData.diner_id.service_type === "SEATING") ||
                        (props.modelData &&
                          props.modelData.diner_id &&
                          props.modelData.diner_id.isWalkIn === true)
                        ? require("../../../../assets/images/seatingImages/chairBlack.png")
                        : (props.modelData &&
                          props.modelData.diner_id &&
                          props.modelData.diner_id.service_type ===
                          "SEATING") ||
                          (props.modelData &&
                            props.modelData.diner_id &&
                            props.modelData.diner_id.isWalkIn === false)
                          ? require("../../../../assets/images/seatingImages/reservationBlack.png")
                          : props.modelData &&
                            props.modelData.diner_id &&
                            props.modelData.diner_id.service_type ===
                            "RESERVATION"
                            ? require("../../../../assets/images/seatingImages/reservationBlack.png")
                            : ""
                    }
                  />
                </div>
                <div>
                  <div className="f12-500">
                    {(props.modelData &&
                      props.modelData.diner_id &&
                      props.modelData.diner_id.service_type === "SEATING") ||
                      (props.modelData &&
                        props.modelData.diner_id &&
                        props.modelData.diner_id.isWalkIn === true)
                      ? "WalkIn"
                      : (props.modelData &&
                        props.modelData.diner_id &&
                        props.modelData.diner_id.service_type ===
                        "SEATING") ||
                        (props.modelData &&
                          props.modelData.diner_id &&
                          props.modelData.diner_id.isWalkIn === false)
                        ? "Waitlist"
                        : props.modelData &&
                          props.modelData.diner_id &&
                          props.modelData.diner_id.service_type === "RESERVATION"
                          ? "Reservation"
                          : ""}
                  </div>
                  <span className="f10-400">
                    {props.modelData &&
                      props.modelData.diner_id &&
                      props.modelData.diner_id.diner_id}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="d-flex align-items-center justify-content-end py-2">
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../assets/images/superadmin/like.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.modelData && props.modelData.likes.length}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  className="mt-2"
                  src={require("../../../../assets/images/superadmin/disslike.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.modelData && props.modelData.dislikes.length}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../assets/images/superadmin/chat.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.modelData && props.modelData.comment.length}
                </div>
              </div>
            </div>
          </div>
          <div className="enFildset">
            <div className="enlbl f12-400">
              <span className=" opacity5">Review Comments</span>
            </div>
            <div className="f14-400">
              {props.modelData && props.modelData.review}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
